module.exports = __webpack_public_path__ + "img/logo-rodape.410286d1.png";